import * as Wizard from '#~/agent/components/wizard/index.js';
import { EVENT_CATEGORIES, EVENT_NAMES, useAnalytics } from '#~/analytics/index.js';
import { Paths } from '#~/routes/index.js';
import { Icon } from '../../icon.jsx';
import type { ReactElement } from 'react';
import { useMount } from '@studio/react-utils/hooks';
import { useNavigate } from 'react-router-dom';
import { OperatingSystem } from '@studio/react-utils/user-agent';

/** `<Setup>` component. */
export const Setup = (): ReactElement => {
  const navigate = useNavigate();
  const { track } = useAnalytics();

  // Track start_download_flow event on mount
  useMount(() => {
    track(EVENT_NAMES.START_DOWNLOAD_FLOW, EVENT_CATEGORIES.ONBOARDING);
  });

  const handleOSSelect = (os: OperatingSystem): void => {
    // Navigate to select step to choose architecture, passing the selected OS
    navigate(`/${Paths.agent.setup.select}`, { state: { os } });
  };

  return (
    <Wizard.Root currentStep={1} totalSteps={3}>
      <Icon />

      <Wizard.Verbiage
        message='To get started, download the Iris desktop application.'
        title='Download Iris'
      />

      <Wizard.ButtonBox className='flex w-[250px] flex-col gap-12 [&_button]:w-full'>
        <Wizard.Button onClick={(): void => handleOSSelect(OperatingSystem.macOS)}>
          Mac
        </Wizard.Button>
        <Wizard.Button onClick={(): void => handleOSSelect(OperatingSystem.Windows)}>
          Windows
        </Wizard.Button>
      </Wizard.ButtonBox>
    </Wizard.Root>
  );
};
